export default "__VITE_ASSET__CH_Xfb2P__"